import React from 'react';

export const AddToCalendarIcon: React.FC<sharedComponents.SvgIcon> = ({ height = 24, width = 24, className = '' }) => (
  <svg
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 24 24"
    className={className}
    fill="#5514B4"
  >
    <path d="M20.25 6v14.25H3.75V6h16.5Zm0-.75H3.75c-.45 0-.75.3-.75.75v14.25c0 .375.3.75.75.75h16.5c.45 0 .75-.375.75-.75V6c0-.45-.3-.75-.75-.75Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M3 9.375C3 9.168 3.168 9 3.375 9h17.25a.375.375 0 0 1 0 .75H3.375A.375.375 0 0 1 3 9.375ZM5.625 3c.207 0 .375.168.375.375v3a.375.375 0 1 1-.75 0v-3c0-.207.168-.375.375-.375ZM18.375 3c.207 0 .375.168.375.375v3a.375.375 0 0 1-.75 0v-3c0-.207.168-.375.375-.375ZM12 12c.207 0 .375.168.375.375v5.25a.375.375 0 0 1-.75 0v-5.25c0-.207.168-.375.375-.375Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M9 15c0-.207.168-.375.375-.375h5.25a.375.375 0 0 1 0 .75h-5.25A.375.375 0 0 1 9 15Z" />
  </svg>
);
